import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "locationCatchmentArea"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "tbdc-grid" }
const _hoisted_5 = { class: "tbdc-row" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { style: {"cursor":"pointer"} }
const _hoisted_10 = { style: {"float":"right","cursor":"pointer","text-align":"right"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_PropertyValue = _resolveComponent("PropertyValue")!
  const _component_BusyLogo = _resolveComponent("BusyLogo")!

  return (_ctx.location)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.top10")) + " " + _toDisplayString(_ctx.$tc("message.areasType" + _ctx.model.areasType + "Name",2).toLowerCase()), 1),
        (_ctx.catchmentArea == null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$tc("message.catchmentAreaNotSelected")), 1))
          : _createCommentVNode("", true),
        (_ctx.locationCatchmentArea != null && _ctx.locationCatchmentArea.areas != null && _ctx.locationCatchmentArea.areas.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.catchmentArea != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$tc("message.catchmentArea")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.catchmentArea != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.catchmentArea.title), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAreas.slice(0, 10), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tbdc-grid tbdc-hover",
                  key: item.areaCode
                }, [
                  _createElementVNode("div", {
                    class: "tbdc-row tbdc-hover",
                    onClick: ($event: any) => (_ctx.setArea(item.areaCode))
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_v_icon, { class: "mr-3" }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("mdi-land-fields", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(item.areaCode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.model.outputType == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createVNode(_component_PropertyValue, {
                              property: {numberValue: item.output, dataType: 3},
                              onlyCurrentValue: true
                            }, null, 8, ["property"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.model.outputType == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _createVNode(_component_PropertyValue, {
                              property: {numberValue: item.output, dataType: 1, roundingDigits: 0 },
                              onlyCurrentValue: true
                            }, null, 8, ["property"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.model.outputType == 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(_component_PropertyValue, {
                              property: {numberValue: item.output, dataType: 3},
                              onlyCurrentValue: true,
                              currency: _ctx.model.currency
                            }, null, 8, ["property", "currency"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.model.outputType == 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _createVNode(_component_PropertyValue, {
                              property: {numberValue: item.output, dataType: 1, roundingDigits: 0},
                              onlyCurrentValue: true
                            }, null, 8, ["property"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1))
                  ], 8, _hoisted_8)
                ]))
              }), 128))
            ]))
          : (_ctx.catchmentArea != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_BusyLogo, {
                  active: true,
                  color: "#b0b0b0",
                  size: 40
                })
              ]))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}